export const TOGGLE_CREATE_MODAL_FOLDER = 'TOGGLE_CREATE_MODAL_FOLDER';
export const TOGGLE_EDIT_MODAL_FOLDER = 'TOGGLE_EDIT_MODAL_FOLDER';
export const TOGGLE_ARCHIVE_MODAL_FOLDER = 'TOGGLE_ARCHIVE_MODAL_FOLDER';
export const TOGGLE_DELETE_MODAL_FOLDER = 'TOGGLE_DELETE_MODAL_FOLDER';
export const TOGGLE_ARCHIVED_MODAL_FOLDERS = 'TOGGLE_ARCHIVED_MODAL_FOLDERS';
export const SET_FETCHING_ARCHIVED = 'SET_FETCHING_ARCHIVED';